import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=7b8d9d8c&scoped=true"
import script from "./LegalNotice.vue?vue&type=script&lang=js"
export * from "./LegalNotice.vue?vue&type=script&lang=js"
import style0 from "./LegalNotice.vue?vue&type=style&index=0&id=7b8d9d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8d9d8c",
  null
  
)

export default component.exports